import { forwardRef } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { SelectField } from './SelectField';
import {
  DonationField,
  US_STATES,
  CANADA_STATES,
  Country,
} from '../../constants';

export const SelectState = forwardRef(({ ...rest }, ref) => {
  const countryWatch = useWatch({ name: DonationField.country });
  const [States, setStates] = useState(US_STATES);

  useEffect(() => {
    if (countryWatch === Country.UnitedStates) {
      setStates(US_STATES);
    }

    if (countryWatch === Country.Canada) {
      setStates(CANADA_STATES);
    }
  }, [countryWatch]);

  return <SelectField {...rest} options={States} inputRef={ref} />;
});
